import {observable, toJS}  from 'mobx';
import {DomainObject} from 'shared/store';

class CalendarEvent extends DomainObject {
  @observable title
  @observable start;
  @observable end;
  @observable allDay;
  @observable extendedProps;
  
  toFullCalendarEvent() {
    return {
      ...toJS(this),
      backgroundColor: this.backgroundColor,
      textColor: this.textColor,
      borderColor: this.borderColor,
      extendedProps: {
        ...this.extendedProps,
        canViewDetails: this.canViewDetails || false
      }
    };
  }
}

export default CalendarEvent;
